// extracted by mini-css-extract-plugin
export default {"container":"ToasContextProvider_container__Y9l8j"};